@charset "UTF-8";

/* libs/shared/src/lib/ui/pagination-footer/pagination-footer.component.scss */
.pf-footer {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  padding: 7px 20px;
  background: #f7f8fa;
  border-top: 1px solid #e5e7eb;
}
.pf-size {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  color: #6b7280;
}
.pf-size select {
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  font-size: 13.5px;
  color: #374151;
  background: #fff;
  cursor: pointer;
}
.pf-divider {
  width: 1px;
  height: 22px;
  background: #e1e4e8;
}
.pf-range {
  font-size: 13.5px;
  color: #374151;
}
.pf-range strong {
  color: #111827;
}
.pf-stepper {
  margin-left: auto;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e1e4e8;
  border-radius: 8px;
  overflow: hidden;
}
.pf-stepper button {
  width: 30px;
  height: 30px;
  border: none;
  background: transparent;
  font-size: 15px;
  color: #374151;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.pf-stepper button:hover:not(:disabled) {
  background: #f3f4f6;
}
.pf-stepper button:disabled {
  color: #cbd5e1;
  cursor: default;
}
.pf-stepper .pf-page {
  padding: 5px 16px;
  font-size: 13.5px;
  color: #374151;
  border-left: 1px solid #e1e4e8;
  border-right: 1px solid #e1e4e8;
  white-space: nowrap;
}
.pf-stepper .pf-page strong {
  color: #111827;
}
/*# sourceMappingURL=pagination-footer.component.css.map */
